import * as tslib_1 from "tslib";
import store from '../../store';
import PopupPay from './popupPay.vue';
import showBindPhone from '@ivy/fts/showBindPhone';
import { toItem } from '../../helper';
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as _ from 'underscore';
import { Toast } from 'mint-ui';
let BuyPanel = class BuyPanel extends Vue {
    constructor() {
        super(...arguments);
        this.store = store;
        this.showPanel = false;
        this.orderType = '';
    }
    get from() {
        let from = this.$route.query.from;
        return ['timeline', 'groupmessage', 'singlemessage'].includes(from) ? 'share' : this.$route.query.from;
    }
    wechatPayOver(res) {
        this.$emit('on-wechat-pay', res);
    }
    async setOrder(type) {
        if (!store.logined.token) {
            return await this.toRelation();
        }
        if (type === 'vip') {
            let from = `${window.location.pathname}${window.location.search}`;
            return this.$router.push({ path: '/vip', query: { from, action: 'callPay' } });
        }
        this.orderType = type;
        this.showPanel = true;
    }
    toItem() {
        let data = _.find(this.audios, au => au.has_access === 1 || au.listen === 1) || this.audios[0];
        if (!data) {
            return Toast('无可试听的音频');
        }
        const opt = { data, type: 'audio', from: this.from, albumId: this.$route.query.albumId, memId: this.$route.query.memId };
        toItem(opt);
    }
    async toRelation() {
        let res = await showBindPhone(); // 弹出绑定手机号的窗口
        // 绑定成功之后重新登录
        if (res.message === 'ok' || res.user) {
            store.logined = res.logined;
            this.$router.go(0);
        }
    }
};
tslib_1.__decorate([
    Prop()
], BuyPanel.prototype, "album", void 0);
tslib_1.__decorate([
    Prop()
], BuyPanel.prototype, "audios", void 0);
BuyPanel = tslib_1.__decorate([
    Component({
        components: { PopupPay }
    })
], BuyPanel);
export default BuyPanel;
